var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19607 6.48788L3.23326 11.2433C2.954 10.5284 2.81128 9.76748 2.81251 9C2.81251 5.58169 5.5817 2.8125 9.00001 2.8125C12.4189 2.8125 15.1875 5.58169 15.1875 9C15.1875 10.89 14.3398 12.5826 13.0033 13.7177H4.9967C4.64621 13.4173 4.32884 13.0803 4.05001 12.7125H11.1161V10.0333L13.3464 12.7125H13.95L11.1133 9.30937L10.3303 10.2499L7.19607 6.48788ZM11.1139 5.2875C10.7108 5.29837 10.328 5.46611 10.0467 5.75502C9.76552 6.04393 9.60817 6.43119 9.60817 6.83437C9.60817 7.23756 9.76552 7.62482 10.0467 7.91373C10.328 8.20264 10.7108 8.37038 11.1139 8.38125C11.5169 8.37038 11.8998 8.20264 12.181 7.91373C12.4622 7.62482 12.6196 7.23756 12.6196 6.83437C12.6196 6.43119 12.4622 6.04393 12.181 5.75502C11.8998 5.46611 11.5169 5.29837 11.1139 5.2875ZM7.1972 4.16756C7.09383 4.16478 6.99096 4.18273 6.89465 4.22036C6.79834 4.25799 6.71055 4.31453 6.63646 4.38665C6.56236 4.45878 6.50347 4.54501 6.46326 4.64027C6.42305 4.73553 6.40233 4.83788 6.40233 4.94128C6.40233 5.04468 6.42305 5.14703 6.46326 5.24229C6.50347 5.33755 6.56236 5.42379 6.63646 5.49591C6.71055 5.56803 6.79834 5.62458 6.89465 5.66221C6.99096 5.69984 7.09383 5.71779 7.1972 5.715C7.39879 5.70956 7.5903 5.62566 7.73096 5.48116C7.87162 5.33665 7.95033 5.14295 7.95033 4.94128C7.95033 4.73962 7.87162 4.54592 7.73096 4.40141C7.5903 4.2569 7.39879 4.173 7.1972 4.16756ZM5.61882 14.1818H12.3818C11.3764 14.839 10.2011 15.1885 9.00001 15.1875C7.79909 15.1884 6.624 14.8389 5.61882 14.1818ZM10.0305 10.6121L8.66588 12.2484H3.73445C3.53741 11.9292 3.36966 11.5927 3.23326 11.2433H7.19663V7.21125L10.0305 10.6121Z",
    fill: "#16141A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana);
export default __webpack_public_path__ + "static/media/mana.c5f6c5e7045c4e16daf8aaebb98de2fb.svg";
export { ForwardRef as ReactComponent };